export const getDropdownOptionsForTypes = (types) => {
    return types.map(option => {
        return { value: option.id, text: option.label, iconName: option.iconName };
    });
};
